<template>
    <v-toolbar :color="toolbarColor" dark dense elevation="0">
        <v-icon left>mdi-account-group</v-icon>
        <v-toolbar-title>Residence Assistant Manager</v-toolbar-title>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>

<script>
export default {
    name: 'residence-assistant-manager-toolbar',
    computed: {
        toolbarColor() {
            return '#3699FF';
        }
    }
}
</script>